/**
 * React 19-compatible wrappers for react-helmet-async.
 *
 * react-helmet-async v2.0.5 uses class components internally, which
 * conflict with React 19's updated JSX type definitions. These thin
 * wrappers provide function component interfaces that delegate to the
 * original components. The cast through unknown is required because
 * React 19 changed the Component base class shape, making the library's
 * class components structurally incompatible at the type level (they
 * still work correctly at runtime).
 */
import { createElement, type ReactNode, type ComponentType } from 'react';
import {
  Helmet as HelmetOriginal,
  HelmetProvider as HelmetProviderOriginal,
} from 'react-helmet-async';

interface HelmetWrapperProps {
  children?: ReactNode;
}

interface HelmetProviderWrapperProps {
  children?: ReactNode;
}

const HelmetCompat = HelmetOriginal as unknown as ComponentType<HelmetWrapperProps>;
const HelmetProviderCompat = HelmetProviderOriginal as unknown as ComponentType<HelmetProviderWrapperProps>;

export function Helmet({ children }: HelmetWrapperProps): React.JSX.Element {
  return createElement(HelmetCompat, null, children);
}

export function HelmetProvider({ children }: HelmetProviderWrapperProps): React.JSX.Element {
  return createElement(HelmetProviderCompat, null, children);
}
